// Shared display mapping for ContentRun status → stage tracker + badges.

export const RUN_STEPS = ['Topic', 'Research', 'Gap', 'Brief', 'Article', 'Handoff'];

export function runMeta(status) {
  switch (status) {
    case 'not_started': return { step: 0, label: 'Queued', tone: 'surface', live: true };
    case 'topic_picking': return { step: 0, label: 'Pick a topic', tone: 'warning', gate: 'topics', live: true };
    case 'harvesting': return { step: 1, label: 'Researching…', tone: 'brand', live: true };
    case 'research_review': return { step: 1, label: 'Research ready — verify', tone: 'warning', gate: 'research' };
    case 'analyzing': return { step: 2, label: 'Gap analysis…', tone: 'brand', live: true };
    case 'gap_review': return { step: 2, label: 'Gap analysis ready — verify', tone: 'warning', gate: 'gap' };
    case 'briefing': return { step: 3, label: 'Writing brief…', tone: 'brand', live: true };
    case 'brief_ready': return { step: 3, label: 'Brief ready for review', tone: 'warning', gate: 1 };
    case 'drafting': return { step: 4, label: 'Drafting article…', tone: 'brand', live: true };
    case 'qa': return { step: 4, label: 'Running QA…', tone: 'brand', live: true };
    case 'review_ready': return { step: 4, label: 'Ready for review', tone: 'warning', gate: 2 };
    case 'handed_off': return { step: 6, label: 'Handed off', tone: 'success' };
    case 'changes_requested': return { step: 3, label: 'Changes requested', tone: 'warning' };
    case 'rejected': return { step: 0, label: 'Rejected', tone: 'error' };
    case 'error': return { step: 0, label: 'Error', tone: 'error' };
    default: return { step: 0, label: status || 'Unknown', tone: 'surface' };
  }
}

export const TONE = {
  brand: 'text-brand-700 bg-brand-50 border-brand-200',
  warning: 'text-warning-700 bg-warning-50 border-warning-200',
  success: 'text-success-700 bg-success-50 border-success-200',
  error: 'text-error-700 bg-error-50 border-error-200',
  surface: 'text-surface-600 bg-surface-100 border-surface-200',
};

export function monthLabel(ym) {
  if (!ym) return '';
  const [y, m] = ym.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}

export function currentMonth(now = new Date()) {
  // Keep in sync with backend CONTENT_STUDIO_TZ (default Asia/Kolkata).
  try {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
    }).formatToParts(now);
    const y = parts.find((p) => p.type === 'year')?.value;
    const m = parts.find((p) => p.type === 'month')?.value;
    if (y && m) return `${y}-${m}`;
  } catch { /* fall through */ }
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

/** @returns {'current'|'past'|'future'} */
export function monthRelation(ym, now = new Date()) {
  const m = String(ym || '').slice(0, 7);
  const cur = currentMonth(now);
  if (!/^\d{4}-\d{2}$/.test(m)) return 'current';
  if (m === cur) return 'current';
  return m < cur ? 'past' : 'future';
}

export function isRegistryConfirmed(client) {
  return !!client?.contentRegistry?.registryConfirmedAt;
}
